import { computed, effect, inject, Injectable, signal } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { getStoredLanguage, Language, LANGUAGE_STORAGE_KEY } from './language-storage';

@Injectable({ providedIn: 'root' })
export class TranslationService {
  private readonly translocoService = inject(TranslocoService);

  private readonly _currentLanguage = signal<Language>(getStoredLanguage());

  readonly currentLanguage = this._currentLanguage.asReadonly();
  readonly isSpanish = computed(() => this._currentLanguage() === 'es');
  readonly isEnglish = computed(() => this._currentLanguage() === 'en');

  readonly availableLanguages: readonly { code: Language; label: string }[] = [
    { code: 'en', label: 'English' },
    { code: 'es', label: 'Español' },
  ] as const;

  constructor() {
    effect(() => {
      const lang = this._currentLanguage();
      this.translocoService.setActiveLang(lang);
      this.storeLanguage(lang);
      document.documentElement.lang = lang;
    });
  }

  setLanguage(language: Language): void {
    this._currentLanguage.set(language);
  }

  toggleLanguage(): void {
    this._currentLanguage.update((current) => (current === 'en' ? 'es' : 'en'));
  }

  private storeLanguage(language: Language): void {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    }
  }
}
